import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowRight, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

// Shown when a new portfolio has selected schools that haven't activated yet.
export const PendingSchoolsBanner = () => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    axios.get(`${API}/api/portfolio-activation/me`, { withCredentials: true })
      .then((r) => setCount((r.data?.schools || []).length)).catch(() => {});
  }, []);
  if (!count) return null;
  return (
    <div data-testid="pending-schools-banner" className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-blue-200 bg-blue-50 px-5 py-4">
      <div className="flex items-center gap-3 text-sm text-slate-700">
        <Clock className="h-5 w-5 text-blue-600 shrink-0" />
        <span><b data-testid="pending-schools-count">{count} school{count === 1 ? "" : "s"}</b> selected and awaiting activation. Scores appear here once each school accepts its invite.</span>
      </div>
      <Button className="bg-[#007a9e] hover:bg-[#00607d]" onClick={() => (window.location.href = "/portfolio/activation")} data-testid="pending-schools-open-activation">
        Open Activation Center <ArrowRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
};
